import axios from 'axios';

import { CompanyDto, UpdateCompanyInfoDto } from '../interfaces/company.dto';

class CompanyService {
  async loadCompany(): Promise<CompanyDto> {
    return (await axios.get<CompanyDto>('company')).data;
  }

  async updateInfo(info: UpdateCompanyInfoDto): Promise<CompanyDto> {
    return (await axios.patch<CompanyDto>('company/info', info)).data;
  }

  async uploadLogo(file: File): Promise<CompanyDto> {
    const formData = new FormData();
    formData.append('image', file);

    return (await axios.post<CompanyDto>('company/logo', formData)).data;
  }

  async removeLogo(): Promise<CompanyDto> {
    return (await axios.delete<CompanyDto>('company/logo')).data;
  }

  async getAdvancedRenterScreening(companyId: string): Promise<boolean> {
    const response = await axios.get<{ advancedRenterScreening: boolean }>(
      `company/${companyId}/advanced-renter-screening`,
    );
    return response.data.advancedRenterScreening;
  }

  async setAdvancedRenterScreening(companyId: string, enabled: boolean): Promise<void> {
    await axios.patch(`company/${companyId}/advanced-renter-screening`, { enabled });
  }
}

export default new CompanyService();
